import React from 'react'

function PaymentMethod() {
  return (
    <div>PaymentMethod</div>
  )
}

export default PaymentMethod